import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appPath'
})
export class PathPipe implements PipeTransform {
  transform(path: string): string {
    if (path === null || typeof path === 'undefined') { return 'empty'; }
    return path;
  }
}
